import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_10: FaireProductEntity = {
  token: "atc_fs_10",
  type: "product",
  name: "Concrete Cowgirl Eau de Parfum",
  brandName: "West Clay Company",
  brandToken: "west-clay-company",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/9007fa5f19edc20337cc2b2748b73ad3e9fb59ee1eacb1e6e01022ca23bea977.webp",
  priceDollars: 32,
  msrpDollars: 64,
  description: "ATC migration seed product",
  tags: ["beauty", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
